import { DateTimePart } from '@mews-framework/datetime';
import { OptimusTextKey } from '@optimus-web/localization';
import { DatePeriod, DatePeriodType, DateUnit } from './types';

export const dateUnitByDateTimePart: Record<DateUnit, DateTimePart> = {
    [DateUnit.Year]: DateTimePart.Year,
    [DateUnit.Quarter]: DateTimePart.Quarter,
    [DateUnit.Month]: DateTimePart.Month,
    [DateUnit.Week]: DateTimePart.Week,
    [DateUnit.Day]: DateTimePart.Day,
};

interface DatePeriodConfig {
    type: DatePeriodType;
    unit: DateUnit;
    label: OptimusTextKey;
    value: DatePeriod;
    withDivider?: boolean;
}

export const datePeriods: Record<DatePeriod, DatePeriodConfig> = {
    [DatePeriod.Today]: {
        type: DatePeriodType.This,
        unit: DateUnit.Day,
        label: OptimusTextKey.Today,
        value: DatePeriod.Today,
    },
    [DatePeriod.Yesterday]: {
        type: DatePeriodType.Last,
        unit: DateUnit.Day,
        label: OptimusTextKey.Yesterday,
        value: DatePeriod.Yesterday,
    },
    [DatePeriod.Tomorrow]: {
        type: DatePeriodType.Next,
        unit: DateUnit.Day,
        label: OptimusTextKey.Tomorrow,
        value: DatePeriod.Tomorrow,
        withDivider: true,
    },
    [DatePeriod.ThisWeek]: {
        type: DatePeriodType.This,
        unit: DateUnit.Week,
        label: OptimusTextKey.ThisWeek,
        value: DatePeriod.ThisWeek,
    },
    [DatePeriod.LastWeek]: {
        type: DatePeriodType.Last,
        unit: DateUnit.Week,
        label: OptimusTextKey.LastWeek,
        value: DatePeriod.LastWeek,
    },
    [DatePeriod.NextWeek]: {
        type: DatePeriodType.Next,
        unit: DateUnit.Week,
        label: OptimusTextKey.NextWeek,
        value: DatePeriod.NextWeek,
        withDivider: true,
    },
    [DatePeriod.ThisMonth]: {
        type: DatePeriodType.This,
        unit: DateUnit.Month,
        label: OptimusTextKey.ThisMonth,
        value: DatePeriod.ThisMonth,
    },
    [DatePeriod.LastMonth]: {
        type: DatePeriodType.Last,
        unit: DateUnit.Month,
        label: OptimusTextKey.LastMonth,
        value: DatePeriod.LastMonth,
    },
    [DatePeriod.NextMonth]: {
        type: DatePeriodType.Next,
        unit: DateUnit.Month,
        label: OptimusTextKey.NextMonth,
        value: DatePeriod.NextMonth,
        withDivider: true,
    },
    [DatePeriod.ThisQuarter]: {
        type: DatePeriodType.This,
        unit: DateUnit.Quarter,
        label: OptimusTextKey.ThisQuarter,
        value: DatePeriod.ThisQuarter,
    },
    [DatePeriod.LastQuarter]: {
        type: DatePeriodType.Last,
        unit: DateUnit.Quarter,
        label: OptimusTextKey.LastQuarter,
        value: DatePeriod.LastQuarter,
    },
    [DatePeriod.NextQuarter]: {
        type: DatePeriodType.Next,
        unit: DateUnit.Quarter,
        label: OptimusTextKey.NextQuarter,
        value: DatePeriod.NextQuarter,
        withDivider: true,
    },
    [DatePeriod.ThisYear]: {
        type: DatePeriodType.This,
        unit: DateUnit.Year,
        label: OptimusTextKey.ThisYear,
        value: DatePeriod.ThisYear,
    },
    [DatePeriod.LastYear]: {
        type: DatePeriodType.Last,
        unit: DateUnit.Year,
        label: OptimusTextKey.LastYear,
        value: DatePeriod.LastYear,
    },
    [DatePeriod.NextYear]: {
        type: DatePeriodType.Next,
        unit: DateUnit.Year,
        label: OptimusTextKey.NextYear,
        value: DatePeriod.NextYear,
        withDivider: true,
    },
    [DatePeriod.Custom]: {
        type: DatePeriodType.Custom,
        label: OptimusTextKey.Custom,
        unit: DateUnit.Day,
        value: DatePeriod.Custom,
    },
};

export const dateRangePeriodDropdownOptions = Object.values(datePeriods).map((datePeriod) => ({
    label: datePeriod.label,
    value: datePeriod.value,
    withDivider: datePeriod.withDivider,
}));
